import * as React from 'react';
import { StyledProgressBox } from './styles';
import LinearProgress from '@mui/material/LinearProgress';

export const ProgressBar = ({ containerWidth, progressColor, value }) => {
  if (value === 0 || containerWidth === 0) {
    return null;
  }
  return (
    <StyledProgressBox sx={{ width: containerWidth || '100%' }} className="tma_progress_container">
      <LinearProgress variant="determinate" sx={{ backgroundColor: progressColor }} value={value} className='tma_progress_bar' />
    </StyledProgressBox>
  );
}
